import { useEffect, useState, useRef } from 'react';
import Draggable from 'react-draggable';
import { useSelector } from "react-redux";
import './styles.css';
import Xarrow, { Xwrapper, useXarrow } from 'react-xarrows';
import { Avatar, Tooltip, TextInput, Button, Select } from "flowbite-react";
import dayjs from "dayjs";
import { getTimeZoneDate } from "../../helpers/data-format";
import { useJwt } from "../../helpers/common";
import SearchPanel from './SearchPanel';
import { exportGanttToImage } from './GanttExportUtil';

function GanntNew({ tasks,onDoubleClick,sim_flag,ZoomClick,scale,duration,isTemplate,duration_with_working_days=0,duration_with_delay=0 }) {
    const JWTdata = useJwt()
    const boxWidth = 75 * scale;
    const boxheight = 54 * scale;
    const updateXarrow = useXarrow();
    const [showArrows, setShowArrows] = useState({});
    const ganttRef = useRef(null);
    const [exportLoading, setExportLoading] = useState(false);
    const [showExportOptions, setShowExportOptions] = useState(false);
    const [exportFormat, setExportFormat] = useState('png');
    
    // Track which task is highlighted from search
    const [highlightedTaskId, setHighlightedTaskId] = useState(null);

    const { 
        org_holidays=[],
    } = useSelector((state: any) => state.roadmap)

    const [boxes, setBoxes] = useState({})

    const org_id = JWTdata.org_id;

    // Function to check if a task is currently highlighted
    const isTaskHighlighted = (taskId) => {
        return highlightedTaskId === taskId;
    };

    const eventLogger = (e, data, boxId) => {
       let  x = data.x;
        setBoxes({ ...boxes, [boxId]: { x: x, y: boxes[boxId].y } })
        setTimeout(()=>{
            updateXarrow()
        },[100])
    };

    useEffect(()=>{
        setTimeout(()=>{
            updateXarrow()
        },[100])
    },[ZoomClick])

    const handleStart = (id) => {
        setShowArrows({ ...showArrows, [id]: false });
        updateXarrow()
    }

    const handleStop = (id) => {
        setShowArrows({ ...showArrows, [id]: true });
    }

    // Add state for toast notification
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    // Simplified export function that uses the utility
    const handleExport = async () => {
        setExportLoading(true);
        try {
            await exportGanttToImage({
                ganttRef,
                format: exportFormat,
                tasks,
                boxes,
                scale,
                boxWidth,
                boxheight,
                duration,
                duration_with_working_days,
                duration_with_delay,
                updateXarrow
            });
        } catch (error) {
            setToastMessage('Failed to export Gantt chart. Please try again.');
            setShowToast(true);
            
            setTimeout(() => setShowToast(false), 3000);
        } finally {
            setExportLoading(false);
            setShowExportOptions(false);
        }
    };

    const taskContainer = {
        borderLeft: "3px solid #5FC976",
        borderTop: "3px solid #b67575",
        display: "flex",
        flex: 1,
        borderRight: "1px solid #394256",
        borderBottom: "1px solid #394256",
        zIndex: 2,
        position: "relative",
        padding: 0
    }

    const ProjectHeader = ({ duration, title, progress }) => {
        const p = `${progress}%`
        return (
            <div style={{ 
                width: `${duration * boxWidth}px`,
                marginLeft: `${boxWidth}px`,
                marginTop: "18px"
            }} className="projectHeader !bg-gray-300 dark:!bg-gray-700 dark:!text-white !text-gray-900 relative h-9">
                <div className="absolute left-[50%] z-10 w-full overflow-hidden" >{title}</div>
                {!isTemplate && (
                    <div className={`absolute left-0 w-[${p}] h-9 top-0 rounded-xl text-xs flex justify-end items-center dark:!text-white !bg-gray-500 !text-gray-700`} title={p} style={{ width: `${p}` }}>{p}</div>
                )}
            </div>  
        )
    }

    const Duration = ({ day,currentDate }) => {
        const textSize = Math.max(scale * 16)
        const dateSize = Math.max(scale * 14)
        let _date = getTimeZoneDate(new Date(currentDate),"DD MMM");
        return (
            <span className="flex flex-col duration dark:!text-white !text-gray-900 text-xs font-normal  relative" style={{ width: `${boxWidth}px` }}>
                <span style={{fontSize:`${textSize}px`, transform: 'none'}}>{day}</span>
                {!isTemplate && <div style={{fontSize:`${dateSize}px`}}>{_date}</div>}
            </span>
        )
    }

    const getWeekdaysArray = (startDate, daysToCount) => {
        let datesArray = [];
        let holidayNotifyList = [];
        let holidayListObj = {};
        let count = 0;
        let date = getTimeZoneDate(startDate);
        let orgWorkingDays =[]
        const orgHolidays = org_holidays && org_holidays.length ? org_holidays.map(d=>d.date) : []

        if(org_id && localStorage){
            let workingDay = localStorage.getItem("workingDays") ? localStorage.getItem("workingDays") : ""
            let workingDays = workingDay ? JSON.parse(workingDay) : {};
            orgWorkingDays = workingDays[org_id] ? workingDays[org_id] : [];
        }
    
        while (count < daysToCount) {
            const formattedDate = getTimeZoneDate(date).format("DD MMM YYYY");
            const formattedDate1 = getTimeZoneDate(date).format("YYYY-MM-DDT00:00:00");
            const isHoliday = orgHolidays.includes(formattedDate1);
            //Check if the current day is not a Saturday (6) or Sunday (0)
            const d = date.day() === 0 ? 7 : date.day()
            if (
                orgWorkingDays.length && 
                orgWorkingDays.includes(d) &&
                !isHoliday
            ) {
                datesArray.push(formattedDate);
                count++;
            } else if (
                d !== 0 && 
                d !== 6 && 
                !orgWorkingDays.length&&
                !isHoliday
            ) {
                datesArray.push(formattedDate);
                count++;
            }
            if(isHoliday){
                const result = org_holidays.find(item => item.date === formattedDate1);
                
                const prevDate = getTimeZoneDate(date).format("DD MMM YYYY")
                holidayListObj[prevDate] = result.name
                holidayNotifyList.push(prevDate)
            }
            date.add(1, "days");
            
        }
        return {weekdaysArray:datesArray,holidayNotifyList,holidayListObj};
    }

    const checkHoliday = (date1,date2,holidayNotifyList) => {
        const format = 'DD MMM YYYY';
        const startDate = dayjs(date1, format);
        const endDate = dayjs(date2, format);

        // Check each date in arr2
        const matchingDates = holidayNotifyList.filter(date => {
            const current = dayjs(date, format);
            return current.isBetween(startDate, endDate, 'day', '[]'); // Include boundaries
        });
        if(matchingDates.length){
            return matchingDates;
        }
        return matchingDates
    }

    const getDateNameString = (holidayListObj, holidays) => {
        let str = '';
        holidays.forEach((date, index) => {
            // Format the date to be more readable
            const formattedDate = dayjs(date, 'DD MMM YYYY').format('DD MMM YYYY');
            const holidayName = holidayListObj[date];
            
            if (index === 0) {
                str += `${holidayName} (${formattedDate})`;
            } else {
                str += `\n${holidayName} (${formattedDate})`;
            }
        });
        return str;
    };

    const CalendarDate = ({duration,start_date}) => {
        const dates = [...new Array(duration)];
        const textSize = Math.max(scale * 12)
        const {weekdaysArray,holidayNotifyList,holidayListObj} = start_date ? getWeekdaysArray(start_date,duration) :[]

        let orgWorkingDays =[]
        if(org_id && localStorage){
            let workingDay = localStorage.getItem("workingDays") ? localStorage.getItem("workingDays") : ""
            let workingDays = workingDay ? JSON.parse(workingDay) : {};
            orgWorkingDays = workingDays[org_id] ? workingDays[org_id] : [];
        }

        // Calculate the maximum height needed based on actual task positions
        const getMaxHeight = () => {
            let maxY = 0;
            // Get the maximum Y position from boxes
            Object.values(boxes).forEach(box => {
                maxY = Math.max(maxY, box.y);
            });
            
            // Add height for all tasks plus extra padding
            const totalTasks = tasks.length;
            const taskSpacing = scale * 20; // Space between tasks
            const totalTasksHeight = totalTasks * (boxheight + taskSpacing);
            
            return Math.max(maxY + (boxheight * 5), totalTasksHeight + 300); // Use whichever is larger
        };

        const totalHeight = Math.max(getMaxHeight(), window.innerHeight * 1.5);

        return (<>
            <span className="days dark:bg-gray-700 bg-white sticky !top-0 z-[9999] flex flex-row" style={{ width: `${duration * boxWidth *4}px`,marginLeft:`${boxWidth}px` }}>
            <div className="dark:text-white text-gray-600 left-[-30px] top-[10px] absolute rotate-[-90deg]">Days</div>
                {dates.map((date,index) => {
                    return (<>
                        <Duration currentDate={weekdaysArray[index]}   className="duration dark:border-slate-800 border-gray-300"  day={index+1} />
                        </>
                    )
                })}
            </span>
            {weekdaysArray.length > 0 ? weekdaysArray.map((date,index) => {
                const dateValidate =  dayjs(dayjs().format('YYYY-MM-DD')).diff(dayjs(`${date}`).format('YYYY-MM-DD'))
                const weekday = dayjs(date).weekday();
                
                const isHoliday = !isTemplate && checkHoliday(weekdaysArray[index],weekdaysArray[index+1],holidayNotifyList);
                return (
                        <div 
                            className={`absolute flex  justify-center top-10  border-gray-400 dark:border-gray-500    ${weekday === orgWorkingDays.length && dateValidate !== 0 ? "!border-r-4 " :  '!border-l-2 '} ${dateValidate === 0 && "!border-green-500"}   dark:text-white mt-1  border-l-[0.5px] group`}
                            style={{ left: `${boxWidth * (index+1)}px`,fontSize:`${textSize}px`,width:`${boxWidth}px`,height: `${totalHeight}px`  }}
                            title={date}
                            key={index}
                        >
                            {isHoliday.length ? 
                                <div className="w-full relative border-r-4 border-orange-500">
                                    <div className="absolute top-0 right-0 bg-gray-700/95 px-2 py-1 text-white border border-orange-500 rounded-sm flex items-center justify-center min-h-[24px]">
                                        {isHoliday.length > 1 ? 
                                            <Tooltip 
                                                content={getDateNameString(holidayListObj, isHoliday)}
                                                style="dark"
                                                placement="top"
                                                className="whitespace-pre-line"
                                            >
                                                <div className="flex items-center">
                                                    <span className="text-[12px] font-medium tracking-wide hover:text-gray-200 cursor-pointer font-['Inter']">
                                                        {isHoliday.length} Holidays
                                                    </span>
                                                </div>
                                            </Tooltip>
                                            : 
                                            <Tooltip 
                                                content={`${holidayListObj[isHoliday[0]]} (${isHoliday[0]})`}
                                                style="dark"
                                                placement="top"
                                            >
                                                <div className="flex items-center">
                                                    <span className="text-[12px] font-medium tracking-wide hover:text-gray-200 cursor-pointer truncate max-w-[100px] inline-block font-['Inter']">
                                                        {holidayListObj[isHoliday[0]]}
                                                    </span>
                                                </div>
                                            </Tooltip>
                                        }
                                    </div>
                                </div> 
                                : ""
                            }
                        </div>
                )
            }) :""}
        </>)
    }


    useEffect(() => {
        let tempBoxes = {}
        tasks.slice(1).map((ele, index) => {
            let x = (ele.start_day + 1) * boxWidth;
            tempBoxes = { ...tempBoxes, [ele.id]: { x: x, y: (index + 1) * scale * 10 } }
        })
        setBoxes(tempBoxes)
        updateXarrow()
    }, [tasks,sim_flag,scale])

    const canvasStyle = {
        width: '100vw',
        minHeight: '100%',
        overflow: 'auto',
    }

    const exportButtonRef = useRef(null);

    // Close export dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (exportButtonRef.current && !exportButtonRef.current.contains(event.target)) {
                setShowExportOptions(false);
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);
        
        // Clean up
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="App relative">
            {/* Toast Notification */}
            {showToast && (
                <div className="fixed top-4 right-4 z-[9999] animate-fade-in">
                    <div className="bg-red-100 dark:bg-red-900 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-100 px-4 py-3 rounded-lg shadow-lg flex items-center">
                        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
                        </svg>
                        <span className="font-medium">{toastMessage}</span>
                    </div>
                </div>
            )}
            
            {/* Search Panel Component */}
            <SearchPanel 
                tasks={tasks} 
                onHighlightChange={setHighlightedTaskId} 
            />
            
            {/* Export buttons - repositioned for better visual alignment */}
            <div className="absolute top-[82px] right-3 z-50 flex" ref={exportButtonRef}>
                <Button 
                    size="sm" 
                    onClick={() => setShowExportOptions(!showExportOptions)}
                    color="light"
                    className="flex items-center shadow-sm"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                    Export
                </Button>
                
                {showExportOptions && (
                    <div className="absolute right-0 top-10 mt-2 p-3 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-lg shadow-lg w-64 z-[9999]">
                        <div className="mb-3">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Format</label>
                            <Select 
                                value={exportFormat}
                                onChange={e => setExportFormat(e.target.value)}
                                size="sm"
                                className="w-full"
                            >
                                <option value="png">PNG (Recommended)</option>
                                <option value="jpeg">JPEG</option>
                                <option value="pdf">PDF</option>
                            </Select>
                        </div>
                        
                        <Button 
                            size="sm" 
                            onClick={handleExport}
                            disabled={exportLoading}
                            color="blue"
                            className="w-full"
                        >
                            {exportLoading ? 'Exporting...' : 
                             `Export as ${exportFormat.toUpperCase()}`}
                        </Button>
                    </div>
                )}
            </div>
            
            <div id="box-container" ref={ganttRef} style={canvasStyle} onScroll={handleStart} >
                {/* <div className="dark:text-white text-gray-600 left-[45px] top-[10px] absolute rotate-[-90deg]">Days</div> */}
                <CalendarDate start_date={tasks[0]?.start} duration={duration ? Number(duration_with_working_days)+ Number(duration) : 0} scale={scale} />
                <ProjectHeader duration={duration_with_delay} progress={tasks[0]?.progress} title={tasks[0]?.name} scale={scale} />
                <Xwrapper updateXarrow={updateXarrow} >
                {tasks.slice(1).map((ele, index) => {
                    let factor = index === 0 ? 1 : index + 1;
                    const delay = ele.delayed_duration || 0;
                    let _totalDuration = Number(ele.duration + delay);
                    
                    // Check if this task is highlighted
                    const highlighted = isTaskHighlighted(ele.id);
                    
                    // Modify task container style for highlighting
                    const highlightStyle = highlighted ? {
                        boxShadow: '0 0 0 3px #FFD700, 0 0 12px 2px #FFD700',
                        zIndex: 100,
                        position: 'relative'
                    } : {};

                    return (
                        ele.dependencies && ele.dependencies.length ?
                         <div key={index} className="">
                             
                                <Draggable
                                    axis="x"
                                    handle=".handle"
                                    defaultPosition={{ x: factor * boxWidth, y: factor *scale * 20 }}
                                    position={{...boxes[ele.id]}}
                                    grid={[boxWidth, boxWidth]}
                                    scale={scale}
                                    onStart={handleStart}
                                    onDrag={(e, data) => eventLogger(e, data, ele.id)}
                                    onStop={handleStop}
                                    disabled={true}>
                                        
                                    <div 
                                        id={ele.id} 
                                        className={`task-container !pl-0 relative flex flex-wrap dark:bg-slate-700 bg-gray-300 text-white handle !w-[${_totalDuration * boxWidth}px] ${!ele.inCriticalPath ? "!border-3 !border-t-[#394256]": ""} ${highlighted ? "search-highlight" : ""}`} 
                                        style={{ ...taskContainer, width: `${_totalDuration * boxWidth}px`, height:`${boxheight}px`, borderLeft:`3px solid ${ele?.skill_color || '#5FC976' }`, scale: scale, ...highlightStyle }} 
                                        onDoubleClick={e=>onDoubleClick(ele)}
                                        title={ele.name}
                                    >
                                        <div className="flex">
                                            {delay ? <div style={{ width: `${delay * boxWidth}px`}} className="bg-gradient-to-r from-gray-400 to-gray-500 p-0">
                                                <div className="absolute w-full p-2 z-10 truncate" style={{width: `${delay * boxWidth}px`}}>
                                                    <span className="dark:text-white text-gray-700 dark:opacity-50 text-[10px] font-normal font-['Inter'] uppercase leading-3 truncate block">
                                                        {delay} Day(s) Delayed
                                                    </span>
                                                </div>
                                            </div> :""}
                                            <div  style={{ width: `${ele.duration * boxWidth}px`}} className="p-0">
                                                <Tooltip content={ele.name}>
                                                    {/* <div className=" icon"><BiTask className="dark:text-white text-2xl" /></div> */}

                                                    {ele.sim_flag && <div className={`left-[8px] top-[-14px] p-1 absolute text-center text-white text-[10px] font-normal font-['Inter'] leading-none  bg-green-400 rounded-lg first-letter:uppercase`}>New</div>}
                                                    {ele.isUpdated && <div className={`left-[8px] top-[-14px] p-1 absolute text-center text-white text-[10px] font-normal font-['Inter'] leading-none  bg-indigo-400 rounded-lg first-letter:uppercase`}>Updated</div>}
                                                    
                                                    <div className="projectContainer absolute w-full p-2 z-10">
                                                        <span 
                                                            className={`${!isTemplate && ele.progress === 100 ? 'text-white' : 'dark:text-white text-gray-700 dark:opacity-50'} text-[10px] font-normal font-['Inter'] uppercase leading-3 block truncate`} 
                                                            title={`${ele.id} | ${ele.duration} Days`}
                                                            style={{width: `${(ele.duration * boxWidth) - 20}px`}}
                                                        >
                                                            {ele.id} | {ele.duration} Days
                                                        </span>
                                                        {scale > 0.65 && (
                                                            <span 
                                                                className={`projectTitle ${!isTemplate && ele.progress === 100 ? 'text-white' : 'dark:text-white text-gray-700'} text-xs font-normal font-['Inter'] leading-[18px] mt-2 block truncate`}
                                                                title={ele.name}
                                                                style={{width: `${(ele.duration * boxWidth) - 20}px`}}
                                                            >
                                                                {ele.name}
                                                            </span>
                                                        )}
                                                    </div>
                                                    {!isTemplate && (
                                                        <div 
                                                            className={`absolute left-0 h-full top-0 dark:bg-slate-800 bg-gray-400`} 
                                                            title={ele.progress} 
                                                            style={{ 
                                                                width: `${(ele.progress / 100) * ele.duration * boxWidth}px`, 
                                                                left: `${delay * boxWidth}px`, 
                                                                backgroundColor: ele.progress === 100 ? '#4CAF50' : '#21ff002b',
                                                                display: isTemplate ? 'none' : 'block'
                                                            }}
                                                        ></div>
                                                    )}
                                                    {ele?.member?.name && scale >0.65 && <div className={`ml-auto rounded-full absolute top-[-${scale * 6}px] right-[-30px] z-[99] ${isTemplate && "hidden"}`}> <Avatar
                                                            alt={ele?.member.name} 
                                                            title={ele?.member.name}
                                                            placeholderInitials={ele?.member?.name?.slice(0,1)}
                                                            img={ele?.member?.image_url}
                                                            rounded
                                                            size="xs"
                                                            className="avatar"
                                                    /></div>}
                                                    {ele?.loss_price ?  <div 
                                                        className={`absolute top-[-10px] !right-1 z-[9999] h-4 text-[10px] rounded bg-red-700 flex justify-center items-center p-1 cursor-pointer ${isTemplate && "hidden"}`}
                                                        title={`Loss : $${ele?.loss_price}`}
                                                    >
                                                        {'$'}
                                                    </div> :""}
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </Draggable>
                                
                                 {ele.dependencies.map(dependencie=>{
                                     // console.log("dependencie  ",dependencie);
                                    return (
                                        <Xarrow
                                            path={"smooth"}
                                            start={dependencie}
                                            end={ele.id}
                                            startAnchor={{ position: "bottom", offset: { y: 2 } }}
                                            endAnchor={{ position: "auto", offset: { x: 0} }}
                                            headSize={5}
                                            strokeWidth={2 * scale}
                                            color={ele?.skill_color || '#5FC976' }
                                            zIndex={0}
                                            animateDrawing={false}
                                            showHead={true}
                                            tailSize={factor * boxWidth}
                                            curveness={true}
                                        />
                                    )
                                })}
                                
                             </div>
                                 

                            :
                            <Draggable
                                key={index}
                                axis="x"
                                handle=".handle"
                                defaultPosition={{ x: factor * boxWidth, y: (factor *scale * 20) -35 }}
                                position={{...boxes[ele.id]}}
                                grid={[boxWidth, boxWidth]}
                                scale={scale}
                                onStart={handleStart}
                                onDrag={(e, data) => eventLogger(e, data, ele.id)}
                                onStop={handleStop}
                                disabled={true}>
                                <div 
                                    id={ele.id} 
                                    className={`task-container relative flex flex-wrap handle dark:bg-slate-700 text-white !w-[${_totalDuration * boxWidth}px] ${!ele.inCriticalPath ? "!border-3 !border-t-[#394256]": ""} ${highlighted ? "search-highlight" : ""}`} 
                                    style={{ ...taskContainer, width: `${_totalDuration * boxWidth}px`, height:`${boxheight}px`, borderLeft:`3px solid ${ele?.skill_color || '#5FC976' }`, scale: scale, ...highlightStyle }} 
                                    onDoubleClick={e=>onDoubleClick(ele)}
                                >
                                    <div className="flex">
                                        {delay ? <div style={{ width: `${delay * boxWidth}px`}} className="bg-gradient-to-r from-gray-400 to-gray-500 p-0">
                                            <div className="absolute w-full p-2 z-10 truncate" style={{width: `${delay * boxWidth}px`}}>
                                                <span className="dark:text-white text-gray-700 dark:opacity-50 text-[10px] font-normal font-['Inter'] uppercase leading-3 truncate block">
                                                    {delay} Day(s) Delayed
                                                </span>
                                            </div>
                                        </div> : ""}
                                        <div  style={{ width: `${ele.duration * boxWidth}px`}} className="p-0">
                                            <Tooltip content={ele.name}>
                                                {/* <div className=" icon"><BiTask className="dark:text-white text-2xl" /></div> */}

                                                {ele.sim_flag && <div className={`left-[8px] top-[-14px] p-1 absolute text-center text-white text-[10px] font-normal font-['Inter'] leading-none  bg-green-400 rounded-lg first-letter:uppercase`}>New</div>}
                                                {ele.isUpdated && <div className={`left-[8px] top-[-14px] p-1 absolute text-center text-white text-[10px] font-normal font-['Inter'] leading-none  bg-indigo-400 rounded-lg first-letter:uppercase`}>Updated</div>}
                                                
                                                <div className="projectContainer absolute w-full p-2 z-10">
                                                    <span 
                                                        className={`${!isTemplate && ele.progress === 100 ? 'text-white' : 'dark:text-white text-gray-700 dark:opacity-50'} text-[10px] font-normal font-['Inter'] uppercase leading-3 block truncate`} 
                                                        title={`${ele.id} | ${ele.duration} Days`}
                                                        style={{width: `${(ele.duration * boxWidth) - 20}px`}}
                                                    >
                                                        {ele.id} | {ele.duration} Days
                                                    </span>
                                                    {scale > 0.65 && (
                                                        <span 
                                                            className={`projectTitle ${!isTemplate && ele.progress === 100 ? 'text-white' : 'dark:text-white text-gray-700'} text-xs font-normal font-['Inter'] leading-[18px] mt-2 block truncate`}
                                                            title={ele.name}
                                                            style={{width: `${(ele.duration * boxWidth) - 20}px`}}
                                                        >
                                                            {ele.name}
                                                        </span>
                                                    )}
                                                </div>
                                                {!isTemplate && (
                                                    <div 
                                                        className={`absolute left-0 h-full top-0 dark:bg-slate-800 bg-gray-400`} 
                                                        title={ele.progress} 
                                                        style={{ 
                                                            width: `${(ele.progress / 100) * ele.duration * boxWidth}px`, 
                                                            left: `${delay * boxWidth}px`, 
                                                            backgroundColor: ele.progress === 100 ? '#4CAF50' : '#21ff002b',
                                                            display: isTemplate ? 'none' : 'block'
                                                        }}
                                                    ></div>
                                                )}
                                                {ele?.member?.name && scale >0.65 && <div className={`ml-auto rounded-full absolute top-[-${scale * 6}px] right-[-30px] z-[99] ${isTemplate && "hidden"}`}> <Avatar
                                                        alt={ele?.member.name} 
                                                        title={ele?.member.name}
                                                        placeholderInitials={ele?.member?.name?.slice(0,1)}
                                                        img={ele?.member?.image_url}
                                                        rounded
                                                        size="xs"
                                                        className="avatar"
                                                /></div>}
                                                {ele?.loss_price ?  <div 
                                                    className={`absolute top-[-10px] !right-1 z-[9999] h-4 text-[10px] rounded bg-red-700 flex justify-center items-center p-1 cursor-pointer ${isTemplate && "hidden"}`}
                                                    title={`Loss : $${ele?.loss_price}`}
                                                >
                                                    {'$'}
                                                </div> :""}
                                            </Tooltip>
                                            </div>
                                        </div>
                                </div>
                            </Draggable>
                            
                    )
                })}
                </Xwrapper>
            </div>
        </div >
    );
}

export default GanntNew;
